module.exports = __webpack_public_path__ + "static/media/TnMante.53c3827f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/TnMante.svg
// module id = 212
// module chunks = 0